module.exports = __webpack_public_path__ + "img/background_meg2.c3800ece.webp";